export default __webpack_public_path__ + "static/media/200304 procrastination.2a89ef95.png";